module["exports"] = ["عورت", "مرد"];
